export const AuthConstants = {
    CAS_NAMESPACE: "ca.hrblock.cas"
};
